import { css, SerializedStyles } from '@emotion/core'

import { Color } from '../../../enums/color'
import { ButtonColor, Variant } from '../types'
import { filledBg, filledText, onColorText, subtleText, tonalText } from './colorTokens'

const getLoadingStylesForVariant = (variant: Variant, color: ButtonColor = 'primary'): SerializedStyles =>
  ({
    filled: css`
      background-color: ${filledBg[color]};
      color: ${filledText[color]};
    `,
    tonal: css`
      color: ${tonalText[color]};
    `,
    outlined: css`
      color: ${subtleText[color]};
    `,
    text: css`
      color: ${subtleText[color]};
    `,
    onColor: css`
      color: ${onColorText[color]};
    `,
    textOnColor:
      color === 'accent'
        ? css`
            color: ${subtleText[color]};
          `
        : css`
            color: ${Color.White};
          `,
  })[variant]

export const getLoadingStyle = (variant: Variant, color: ButtonColor = 'primary') => css`
  ${getLoadingStylesForVariant(variant, color)};
  pointer-events: none;
  user-select: none;
`
